import React from 'react';
import Container from './../Container/Container';
import * as Styles from './SiteHeader.Styles';
import ContainerBG from '../ContainerBG/ContainerBG';

const SiteHeader = ({ image, text, bgPos, ...props }) => {
  return (
    <ContainerBG image={image} {...props}>
      <Container fluid flex height='400px' padding='0 16px'>
        <Styles.Header>{text}</Styles.Header>
      </Container>
    </ContainerBG>
  );
};

export default SiteHeader;
